// These Properties should always be scrubbed during an Anonymous Tracking Session
// Note: Scrubbing means overriding these properties with a specific mask, which
// also will override internal properties with the masked values

export const PROPERTIES_TO_SCRUB = [
// Properties that can be used to Track User Navigation
'viralSourcePortalId', 'viralSourceUserId', 'referrerUrl', 'referrerParams',
// Properties that are defined internally by `usage-tracker-core`
// on the `metaProperties` generation
'lastPageUrl',
// Scrub Sensitive Properties that can be defined by the User such as User Identifiable Properties
// Note: These come originally from `SENSITIVE_PROPERTIES` of `usage-tracker-core/constants`
'email', 'userId', 'hubId', 'hstc', 'utk'];

// Fingerprinting used for LogFetch and Sentry to qualify Error messages as belonging to quartz-tracking
export const SENTRY_FINGERPRINT = ['quartz', 'quartz-tracking', 'network'];

// Quartz Auth modes that should be treated as being unauthenticated and work with unauthenticated tracking
export const ALLOWED_UNAUTHED_TYPES = ['hubless', 'none'];

// Portal Id used for HubSpotter Auth Environments, to refer this is Internal.
export const HUBSPOTTER_PORTAL_ID = 53;